function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 72,
  width: 221,
  height: 155,
  fill: "#262626",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 97.0869,
  y: 108.559,
  width: 35.5824,
  height: 13.4422,
  rx: 1,
  fill: "#D8D8D8",
  stroke: "#979797"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 158.764,
  y: 99.0703,
  width: 139.958,
  height: 15.8144,
  rx: 1,
  fill: "#313131"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 177.346,
  y: 106.188,
  width: 63.653,
  height: 1.9768,
  rx: 0.9884,
  fill: "#D6D6D6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.233 111.723C291.853 111.723 293.977 109.599 293.977 106.979C293.977 104.358 291.853 102.234 289.233 102.234C286.612 102.234 284.488 104.358 284.488 106.979C284.488 109.599 286.612 111.723 289.233 111.723Z",
  fill: "#D6D6D6"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 158.764,
  y: 122.793,
  width: 139.958,
  height: 15.8144,
  rx: 1,
  fill: "#313131"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 177.346,
  y: 129.908,
  width: 77.0952,
  height: 1.9768,
  rx: 0.9884,
  fill: "#D6D6D6"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.233 135.444C291.853 135.444 293.977 133.32 293.977 130.699C293.977 128.079 291.853 125.955 289.233 125.955C286.612 125.955 284.488 128.079 284.488 130.699C284.488 133.32 286.612 135.444 289.233 135.444Z",
  fill: "#D6D6D6"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 158.764,
  y: 146.514,
  width: 139.958,
  height: 15.8144,
  rx: 1,
  fill: "#313131"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 177.346,
  y: 153.631,
  width: 51.7922,
  height: 1.9768,
  rx: 0.9884,
  fill: "#D6D6D6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.233 159.164C291.853 159.164 293.977 157.04 293.977 154.42C293.977 151.8 291.853 149.676 289.233 149.676C286.612 149.676 284.488 151.8 284.488 154.42C284.488 157.04 286.612 159.164 289.233 159.164Z",
  fill: "#D6D6D6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.462 157.584C169.209 157.584 170.625 156.168 170.625 154.421C170.625 152.674 169.209 151.258 167.462 151.258C165.715 151.258 164.299 152.674 164.299 154.421C164.299 156.168 165.715 157.584 167.462 157.584Z",
  stroke: "#D6D6D6",
  strokeWidth: 2
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 158.764,
  y: 170.236,
  width: 139.958,
  height: 15.8144,
  rx: 1,
  fill: "#313131"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 177.346,
  y: 177.352,
  width: 63.653,
  height: 1.9768,
  rx: 0.9884,
  fill: "#D6D6D6"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M289.233 182.887C291.853 182.887 293.977 180.763 293.977 178.143C293.977 175.523 291.853 173.398 289.233 173.398C286.612 173.398 284.488 175.523 284.488 178.143C284.488 180.763 286.612 182.887 289.233 182.887Z",
  fill: "#D6D6D6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.462 181.306C169.209 181.306 170.625 179.89 170.625 178.143C170.625 176.397 169.209 174.98 167.462 174.98C165.715 174.98 164.299 176.397 164.299 178.143C164.299 179.89 165.715 181.306 167.462 181.306Z",
  stroke: "#D6D6D6",
  strokeWidth: 2
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  y: 83,
  width: 59,
  height: 143,
  fill: "#313131"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  x: 99.8545,
  y: 99.4668,
  width: 35.5824,
  height: 9.09328,
  rx: 2,
  fill: "#D6D6D6"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  x: 99.8545,
  y: 123.979,
  width: 35.5824,
  height: 15.8144,
  rx: 2,
  fill: "#D6D6D6"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  x: 99.8545,
  y: 146.514,
  width: 35.5824,
  height: 15.8144,
  rx: 2,
  fill: "#D6D6D6"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  x: 99.8545,
  y: 170.236,
  width: 35.5824,
  height: 15.8144,
  rx: 2,
  fill: "#D6D6D6"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  x: 99.8545,
  y: 193.957,
  width: 35.5824,
  height: 15.8144,
  rx: 2,
  fill: "#D6D6D6"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.134 79.5C95.2258 79.5 96.1108 78.6046 96.1108 77.5C96.1108 76.3954 95.2258 75.5 94.134 75.5C93.0423 75.5 92.1572 76.3954 92.1572 77.5C92.1572 78.6046 93.0423 79.5 94.134 79.5ZM101.25 79.5C102.342 79.5 103.227 78.6046 103.227 77.5C103.227 76.3954 102.342 75.5 101.25 75.5C100.158 75.5 99.2734 76.3954 99.2734 77.5C99.2734 78.6046 100.158 79.5 101.25 79.5ZM110.343 77.5C110.343 78.6046 109.458 79.5 108.366 79.5C107.275 79.5 106.39 78.6046 106.39 77.5C106.39 76.3954 107.275 75.5 108.366 75.5C109.458 75.5 110.343 76.3954 110.343 77.5Z",
  fill: "#D8D8D8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57 252H103V297H57V252Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M101.935 252C101.92 252.013 101.904 252.028 101.885 252.044C101.693 252.208 101.349 252.411 100.812 252.632C99.747 253.07 98.1453 253.486 96.0921 253.843C92.002 254.555 86.312 255 80 255C73.688 255 67.998 254.555 63.9079 253.843C61.8547 253.486 60.253 253.07 59.1877 252.632C58.6507 252.411 58.3073 252.208 58.1149 252.044C58.0959 252.028 58.0796 252.013 58.0654 252C58.0796 251.987 58.0959 251.972 58.1149 251.956C58.3073 251.792 58.6507 251.589 59.1877 251.368C60.253 250.93 61.8547 250.514 63.9079 250.157C67.998 249.445 73.688 249 80 249C86.312 249 92.002 249.445 96.0921 250.157C98.1453 250.514 99.747 250.93 100.812 251.368C101.349 251.589 101.693 251.792 101.885 251.956C101.904 251.972 101.92 251.987 101.935 252ZM57.9819 251.904C57.9821 251.904 57.9832 251.905 57.9848 251.909C57.9826 251.905 57.9817 251.904 57.9819 251.904ZM57.9819 252.096C57.9817 252.096 57.9826 252.095 57.9848 252.091C57.9832 252.095 57.9821 252.096 57.9819 252.096ZM102.015 252.091C102.017 252.095 102.018 252.096 102.018 252.096C102.018 252.096 102.017 252.095 102.015 252.091ZM102.015 251.909C102.017 251.905 102.018 251.904 102.018 251.904C102.018 251.904 102.017 251.905 102.015 251.909Z",
  fill: "#121212",
  stroke: "white",
  strokeWidth: 2
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.438 162.99C14.5977 141.129 29.9613 144.518 37.3273 151.4C40.8445 154.687 50.7515 164.317 54.9408 174.458C59.525 185.555 67.1627 197.431 71.7061 209.493C80.4015 232.577 69.5223 237.675 64.4152 236.71C59.0497 235.697 48.546 212.193 42.9394 198.932C37.8303 186.848 24.6993 173.413 21.438 162.99Z",
  fill: "#121212",
  stroke: "white",
  strokeWidth: 2
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2758 286.126C79.2758 286.126 73.3513 263.097 70.0824 237.461C66.8136 211.826 40.8882 173.768 40.8882 173.768",
  stroke: "white",
  strokeWidth: 2
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.06 107.042C110.793 85.439 96.3439 84.2959 92.031 100.053C87.7181 115.81 85.9298 128.069 84.221 136.306C81.2313 150.718 80.2635 153.394 77.6477 170.303C73.3964 197.785 77.9622 208.865 95.0945 191.06C106.406 179.305 105.13 162.518 107.006 141.729C107.971 131.031 115.17 114.382 114.06 107.042Z",
  fill: "#121212",
  stroke: "white",
  strokeWidth: 2
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M82.6541 259.025C82.6541 259.025 85.0426 226.396 85.226 207.851C85.4095 189.305 97.5443 123.432 97.5443 123.432",
  stroke: "white",
  strokeWidth: 2
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.068 148.992C120.503 111.322 107.395 122.571 103.243 141.488C99.0921 160.405 99.4992 163.782 90.6339 183.546C80.9934 205.039 86.7637 228.578 93.2163 234.061C93.6712 234.447 93.2294 234.124 93.8815 233.852C96.2018 232.885 104.368 227.546 107.926 221.994C117.389 207.227 117.422 199.29 119.746 186.858C121.484 177.567 127.021 165.104 125.068 148.992Z",
  fill: "#121212",
  stroke: "white",
  strokeWidth: 2
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M87.3728 259.588L111.806 156.112",
  stroke: "white",
  strokeWidth: 2
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.8521 124.381C46.5404 101.689 57.915 100.738 64.1548 110.558C66.3632 114.033 76.3598 136.537 78.3229 144.922C81.9065 160.23 78.7995 171.826 82.0303 190.429C87.0309 219.223 82.0706 226.581 68.1222 215.636C65.0881 213.255 56.7992 198.807 54.9686 190.296C53.1536 181.858 54.5315 172.395 52.4557 163.326C49.1208 148.757 42.6575 134.466 43.8521 124.381Z",
  fill: "#121212",
  stroke: "white",
  strokeWidth: 2
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M78.9842 261.245C78.9842 261.245 78.5127 228.492 75.2438 202.857C71.9749 177.221 59.4244 143.959 59.4244 143.959",
  stroke: "white",
  strokeWidth: 2
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 51.165,
  y: 296.861,
  width: 58.5682,
  height: 1.17725,
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M163.508 105.594L165.88 107.769L169.954 103.42",
  stroke: "#00FF7F",
  strokeWidth: 1.75
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M163.508 130.503L165.88 132.677L169.954 128.328",
  stroke: "#00FF7F",
  strokeWidth: 1.75
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 89,
  y: 82,
  width: 219,
  height: 2,
  fill: "#545454"
});

var SvgIlluEmptyOndark = function SvgIlluEmptyOndark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 344,
    viewBox: "0 0 344 344",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIlluEmptyOndark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illu_empty_ondark.87665718.svg";
export { ForwardRef as ReactComponent };